import React from "react";
import * as Sentry from "@sentry/react";
import { Modal, Box } from "@material-ui/core";
import { Elements } from "@stripe/react-stripe-js";
import PaymentForm2 from "../stripe/PaymentForm2";
import { stripeTestPromise } from "../../store/constants/baseUrl";

const AddPaymentMethod = ({
  open,
  buttonClicked,
  cardComplete,
  formID,
  firstNameToggle,
  fullName,
  userInfo,
  setfirstNameToggle,
  setfullName,
  setformID,
  handleCloseCardModal,
  handleShowCardAddedModal,
  handleShowBookingErrorModal,
  onCardChange,
  submitWrapper,
}) => {
  return (
    <Modal
      open={open}
      BackdropProps={{ style: { backgroundColor: "rgba(120,118,161,0.5)" } }}
      onClose={(event, reason) => {
        try {
          // Keep existing behavior: block backdrop/Escape while submitting.
          if (
            buttonClicked &&
            (reason === "backdropClick" || reason === "escapeKeyDown")
          ) {
            return;
          }
        } catch (err) {
          Sentry.captureException(err);
          console.log(err);
        }
        handleCloseCardModal();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "calc(100% - 24px)",
          maxWidth: 640,
          maxHeight: "84vh",
          overflowY: "hidden",
          overflowX: "hidden",
          backgroundColor: "#F6F6F6",
          borderRadius: 20,
          padding: 0,
          outline: "none",
        }}
      >
        <div className="relative px-[18px] pt-4 pb-[14px] md:px-7 md:pt-5  font-instrument">
          <button
            onClick={handleCloseCardModal}
            aria-label="Close"
            className="absolute left-4 top-4 h-8 w-8 flex items-center justify-center"
          >
            <img src="/Vision Agent Icons/X Icon/XLightpurple.svg" alt="Close" />
          </button>

          <div className="relative mx-auto mt-2 w-[94px] h-[94px] rounded-full bg-[#E3E3FF] flex items-center justify-center">
            <svg
              width="62"
              height="44"
              viewBox="0 0 62 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <rect
                x="1.5"
                y="2"
                width="59"
                height="40"
                rx="10"
                stroke="#3E3A98"
                strokeWidth="3"
              />
              <line
                x1="2"
                y1="18.5"
                x2="60"
                y2="18.5"
                stroke="#3E3A98"
                strokeWidth="3"
              />
            </svg>
            <div className="absolute -right-1.5 top-1 h-[32px] w-[32px] flex items-center justify-center">
              <img
                src="/images/NewUiIcons/Polygon4.svg"
                alt="Alert"
                className="absolute"
              />
              <img
                src="/images/NewUiIcons/AttentionIconlatest.svg"
                alt="Warning"
                className="relative w-[17px] h-[17px] mt-1"
              />
            </div>
          </div>

          <h2 className="mt-3 text-center text-[20px] leading-[1.1] md:text-[32px] font-semibold text-[#34318C]">
            Add payment method
          </h2>

          <p className="mt-2.5 text-center text-[13px] md:text-[15px] leading-[19px] md:leading-[22px] text-[#34318C] max-w-[500px] mx-auto">
            We only charge your card <span className="font-bold">after your job is completed.</span>{" "}
            Adding a card helps us confirm your booking and match you with a mover.
          </p>

          <div className="mt-4 w-full rounded-[14px] bg-[#E6E6E6] border border-transparent focus-within:border-[#7876A1] px-4 h-12 flex items-center text-[#373559] font-instrument font-normal text-[14px] leading-[20px]">
            <div className="flex-1 min-w-0 flex items-center gap-[5px]">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                className="text-[#7876A1] shrink-0"
              >
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
              </svg>

              {firstNameToggle ? (
                <span className="truncate text-[14px] leading-[20px] text-[#373559] font-normal">
                  {fullName ? fullName : userInfo?.firstName + " " + userInfo?.lastName}
                </span>
              ) : (
                <input
                  value={fullName}
                  onChange={(e) => setfullName(e.target.value)}
                  placeholder="Full name"
                  className="w-full bg-transparent focus:outline-none text-[14px] leading-[20px] text-[#373559] placeholder-[#373559] font-instrument font-normal"
                ></input>
              )}
            </div>
            <button
              type="button"
              className="ml-2 text-[#7876A1]"
              onClick={() => setfirstNameToggle(!firstNameToggle)}
              aria-label="Edit full name"
            >
              <i className="far fa-edit"></i>
            </button>
          </div>

          <div className="mt-3 w-full text-[#34318C]">
            <Elements stripe={stripeTestPromise}>
              <PaymentForm2
                userId={userInfo?.id}
                handleCloseCardModal={handleCloseCardModal}
                handleShowCardAddedModal={handleShowCardAddedModal}
                handleShowBookingErrorModal={handleShowBookingErrorModal}
                onCardChange={onCardChange}
                submitWrapper={submitWrapper}
              />
            </Elements>
          </div>

          <div className="mt-[20px] grid grid-cols-2 gap-3 font-semibold">
            <button
              onClick={handleCloseCardModal}
              className="h-[56px] rounded-[16px] bg-[#C8C6DF] text-[#34318C] text-[16px] leading-none"
            >
              Cancel
            </button>
            <button
              form={formID}
              onClick={() => {
                try {
                  setformID("payment-in-booking");
                } catch (error) {
                  Sentry.captureException(error);
                  console.log(error);
                }
              }}
              disabled={buttonClicked || !cardComplete}
              aria-busy={buttonClicked}
              className={`h-[56px] rounded-[16px] text-white text-[16px] leading-[1.05] px-4 flex items-center justify-center ${
                buttonClicked || !cardComplete
                  ? "bg-slate-500 cursor-not-allowed"
                  : "bg-[#34318C]"
              }`}
            >
              {buttonClicked ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                  Adding...
                </>
              ) : !cardComplete ? (
                <span className="text-[14px]">Enter card details</span>
              ) : (
                <span>Add payment method</span>
              )}
            </button>
          </div>

          <p className="mt-3 text-center text-[#34318C] text-[12px] md:text-[14px] leading-[16px] max-w-[270px] md:max-w-[400px] mx-auto font-instrument">
            <span className="italic">Powered by Stripe.</span> You may see a temporary authorization of $1.00 to verify your card.
          </p>
        </div>
      </Box>
    </Modal>
  );
};

export default AddPaymentMethod;
